import React from 'react';
import PropTypes from 'prop-types';

import { MUIModal } from 'Components/Base';

import LoginSuccessContent from './LoginSuccessContent';

const LoginSuccessModal = ({ isOpen, ...props }) => {
  return (
    <MUIModal
      isOpen={isOpen}
      closeIcon={false}
      modalStyle={{
        boxShadow: '0px 2px 20px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        maxWidth: '324px',
        height: '320px',
      }}
      {...props}
    >
      <LoginSuccessContent />
    </MUIModal>
  );
};

LoginSuccessModal.propTypes = {
  isOpen: PropTypes.bool,
};

export default LoginSuccessModal;
